import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6502ca04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Specifications" }
const _hoisted_2 = { class: "specificationsItemTitle" }
const _hoisted_3 = {
  key: 0,
  class: "specificationsRange"
}
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1))
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = {
  key: 1,
  class: "specificationsInput"
}
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = {
  key: 2,
  class: "specificationsSelect"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attr, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "specificationsItem",
        key: idx
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1),
        (item.attributeType=="range")
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "请输入",
                type: "text",
                "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value[0]) = $event)
              }, null, 8, _hoisted_4), [
                [_vModelText, $setup.data[idx].value[0]]
              ]),
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                placeholder: "请输入",
                type: "text",
                "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value[1]) = $event)
              }, null, 8, _hoisted_6), [
                [_vModelText, $setup.data[idx].value[1]]
              ])
            ]))
          : _createCommentVNode("", true),
        (item.attributeType=="input")
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "请输入",
                type: "text",
                "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value) = $event)
              }, null, 8, _hoisted_8), [
                [_vModelText, $setup.data[idx].value]
              ])
            ]))
          : _createCommentVNode("", true),
        (item.attributeType=="select")
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "select",
                onClick: ($event: any) => {_ctx.isPickerShow = true;_ctx.pickerIdx = idx}
              }, _toDisplayString($setup.data[idx].value||'请选择'), 9, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_VanButton, {
        block: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.setData($setup.attr)))
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_VanButton, {
        type: "success",
        block: "",
        onClick: $setup.confirm
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ]))
}